import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

export function CEOGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  // CEO only. is_ceo is the authoritative flag (a CEO is always role=director,
  // but not every director is CEO) — redirect anyone without it.
  if (!user?.is_ceo) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
